import React from "react";
import styles from "./BetTableTeen20.module.css";

const BetTableTeen20 = ({ playerAData = [], playerBData = [], exposures = {} }) => {
  const getScore = (data, label) => {
    return data?.find((item) => item?.nat === label) || { b: 0, bs: 0 };
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined;
  };

  // Get exposure value
  const getExposure = (label) => {
    const exposureKeys = [
      label,
      label.toLowerCase(),
      label.trim(),
      label.toLowerCase().trim(),
    ].filter(Boolean);

    for (const key of exposureKeys) {
      if (exposures[key] !== undefined && exposures[key] !== 0) {
        return parseFloat(exposures[key]) || 0;
      }
    }
    return 0;
  };

  // Player A data
  const playerADataObj = getScore(playerAData, "Player A");
  const pairPlusAData = getScore(playerAData, "Pair Plus A");
  const backAValue = playerADataObj?.b || 0;
  const backAExposure = playerADataObj?.bs || getExposure("Player A") || 0;
  const backASuspended = isSuspended(playerADataObj);
  const pairPlusAValue = pairPlusAData?.b || 0;
  const pairPlusAExposure = pairPlusAData?.bs || getExposure("Pair Plus A") || 0;
  const pairPlusASuspended = isSuspended(pairPlusAData);

  // Player B data
  const playerBDataObj = getScore(playerBData, "Player B");
  const pairPlusBData = getScore(playerBData, "Pair Plus B");
  const backBValue = playerBDataObj?.b || 0;
  const backBExposure = playerBDataObj?.bs || getExposure("Player B") || 0;
  const backBSuspended = isSuspended(playerBDataObj);
  const pairPlusBValue = pairPlusBData?.b || 0;
  const pairPlusBExposure = pairPlusBData?.bs || getExposure("Pair Plus B") || 0;
  const pairPlusBSuspended = isSuspended(pairPlusBData);

  return (
    <div className={`${styles.casinoDetail} ${styles.casinoBox} ${styles.teenpatti20}`}>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr >
              <th className={styles.box5}></th>
              <th style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '10px', color: '#000' }} className={`${styles.box2} ${styles.back} ${styles.textCenter}`}>Back</th>
              <th className={`${styles.box3} ${styles.back} ${styles.textCenter}`}></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={`${styles.box5} ${styles.playerName}`}>Player A</td>
              <td className={`${styles.textCenter} ${styles.box2} ${styles.back} ${backASuspended ? styles.suspended : ""}`}>
                <span className={`${styles.dBlock} ${styles.textBold}`}>{backAValue || "0"}</span>
                <span className={styles.dBlock} style={{ color: 'black' }}>
                  {backAExposure || "0"}
                </span>
              </td>
              <td className={`${styles.textCenter} ${styles.box3} ${styles.back} ${pairPlusASuspended ? styles.suspended : ""}`}>
                <span className={`${styles.dBlock} ${styles.textBold}`}>
                  <b>Pair Plus A</b>
                </span>
                <span className={styles.dBlock} style={{ color: 'black' }}>
                  {pairPlusAExposure || "0"}
                </span>
              </td>
            </tr>
            <tr>
              <td className={`${styles.box5} ${styles.playerName}`}>Player B</td>
              <td className={`${styles.textCenter} ${styles.back} ${styles.box2} ${backBSuspended ? styles.suspended : ""}`}>
                <span className={`${styles.dBlock} ${styles.textBold}`}>{backBValue || "0"}</span>
                <span className={styles.dBlock} style={{ color: 'black' }}>
                  {backBExposure || "0"}
                </span>
              </td>
              <td className={`${styles.textCenter} ${styles.box3} ${styles.back} ${pairPlusBSuspended ? styles.suspended : ""}`}>
                <span className={`${styles.dBlock} ${styles.textBold}`}>
                  <b>Pair Plus B</b>
                </span>
                <span className={styles.dBlock} style={{ color: 'black' }}>
                  {pairPlusBExposure || "0"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BetTableTeen20;

